import styles from './styles.module.css';
import { Icon } from '../../index';
import { Icons } from '../../Icon/Icon';

const OverviewFolder = ({
    itemLength = 0,
    image,
    name,
    type = 'secondary',
    responsive = false,
    folderColor,
    icon,
    ...props
}: {
    name: string;
    image: string;
    itemLength?: number;
    type?: 'secondary';
    onClick?: any;
    responsive?: boolean;
    folderColor?: string;
    icon?: Icons | null;
}) => {
    return (
        <div
            className={`${styles.folderContainer} 
            ${responsive ? styles.responsive : ''}
            ${type ? styles.secondary : ''} `}
            {...props}
        >
            <div className={styles.folder}>
                <div className={styles.itemWrapper}>{itemLength > 0 && <div className={styles.item}></div>}</div>

                <div className={styles.imgContainer}>
                    {/*<img*/}
                    {/*    className={`${styles.folderImg} ${type ? styles.secondary : ''}`}*/}
                    {/*    src={`/images/folder${!!type ? '-secondary' : ''}.png`}*/}
                    {/*    alt=""*/}
                    {/*/>*/}
                    <span
                        className={`${styles.folderImg} 
                        ${type ? styles.secondary : ''} 
                        ${folderColor ? styles[`folder-color-${folderColor}`] : ''}`}
                    >
                        <Icon icon={Icons.folderLarge} />
                    </span>
                    {!!image && (
                        <img
                            className={`${styles.typeImg} ${type ? styles.secondary : ''}`}
                            src={image || undefined}
                            alt=""
                        />
                    )}
                </div>
            </div>

            <p className={styles.type}>
                {icon && <Icon icon={icon} />}
                {name}
            </p>
        </div>
    );
};

export default OverviewFolder;
